import {Element} from "react-scroll";
import React from "react";
import {Card, CardBody, CardTitle, CardText, Container} from "reactstrap";
import {useTranslation, Trans} from "react-i18next";

function AboutUs() {
    const {t} = useTranslation();

    return (
        <Element name="aboutUs">
            <Container className="my-5">
                <Card className="shadow-lg rounded-4 border-0">
                    <CardBody className="p-5">
                        <CardTitle tag="h2" className="text-center mb-4 text-success">
                            {t("aboutUsTitle")}
                        </CardTitle>

                        <CardText className="mb-4">
                            <Trans i18nKey="aboutUsBody1" component={{strong: <strong/>}}></Trans>
                        </CardText>

                        <CardText className="mb-4">
                            <Trans i18nKey="aboutUsBody2" component={{strong: <strong/>}}></Trans>
                        </CardText>

                        <CardText className="mb-4">
                            <Trans i18nKey="aboutUsBody3" component={{strong: <strong/>}}></Trans>
                        </CardText>

                        <CardText className="mb-4">
                            <Trans i18nKey="aboutUsBody4" component={{strong: <strong/>}}></Trans>
                        </CardText>

                        <CardText className="mb-4">
                            <Trans i18nKey="aboutUsBody5" component={{strong: <strong/>}}></Trans>
                        </CardText>

                        <CardText className="mb-4">
                            <Trans i18nKey="aboutUsBody6" component={{strong: <strong/>}}></Trans>
                        </CardText>

                        <CardText className="mb-4">
                            <Trans i18nKey="aboutUsBody7" component={{strong: <strong/>}}></Trans>
                        </CardText>

                        <CardText className="mb-4">
                            <Trans i18nKey="aboutUsBody8" component={{strong: <strong/>}}></Trans>
                        </CardText>
                    </CardBody>
                </Card>
            </Container>
        </Element>
    )
}

export default AboutUs;